export default __webpack_public_path__ + "static/media/fa-v4compatibility.ea853511.ttf";